// Import style
import './style.scss';

export default class Settings {
	// eslint-disable-next-line require-jsdoc
	constructor() {}
}
